var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7145 8.67969C17.7145 8.67969 17.2167 14.8534 16.928 17.454C16.7905 18.6961 16.0232 19.4239 14.7665 19.4469C12.3749 19.4899 9.98055 19.4927 7.58989 19.4423C6.3808 19.4175 5.62639 18.6805 5.49164 17.4604C5.20105 14.8369 4.70605 8.67969 4.70605 8.67969",
    stroke: "#FF0909",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9825 5.72005H3.43768",
    stroke: "#FF0909",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9872 5.71973C15.2676 5.71973 14.648 5.21098 14.5068 4.50607L14.284 3.3914C14.1465 2.87715 13.6809 2.52148 13.1501 2.52148H9.26988C8.73913 2.52148 8.27347 2.87715 8.13597 3.3914L7.91322 4.50607C7.77205 5.21098 7.15238 5.71973 6.4328 5.71973",
    stroke: "#FF0909",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashRed);
export default __webpack_public_path__ + "static/media/trash-red.caa1b4e0c491e8d431da933d1e46ba36.svg";
export { ForwardRef as ReactComponent };